import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

function HeroAd() {
    return (
        <div className='home-hero-ad-main'>
            <div className='home-hero-ad-sub about-gap-reverse custom-settle'>
                <Container>
                    <Row className='gy-4'>
                        <Col className='col-12 d-grid about-gap-hero'>
                            <div className='flex-center-align'>
                                <div className='cs-container-lg d-grid gap-3 text-center'>
                                    <h2 className='fs-48 m-0 fs-md-35 fs-sm-25 fw-semibold'>We Are Global Exporters</h2>
                                    <p className='fs-md-14 fs-sm-12 m-0'>Nexus Paper Packs has achieved a dominant presence in the global export market due to our unwavering commitment to delivering high-quality products. Our reputation for excellence has enabled us to successfully export to prominent international destinations, including the UK, USA, Canada, Australia, and the UAE. We take pride in providing top-tier packaging solutions that meet the diverse needs of our global clientele, solidifying our position as a trusted exporter in the industry.</p>
                                </div>
                            </div>
                        </Col>
                        <Col
                            className='col-12 col-md-6 d-grid home-hero-ad-content pe-md-5'>
                            <div className='home-hero-head p-3 p-md-4 text-center'>
                                <h4 className='fs-32 fs-md-20 fs-sm-18 m-0'>Our Mission</h4>
                            </div>
                            <div className='home-hero-body d-grid'>
                                <p className='m-0 fs-lg-14 fs-sm-12 text-center'>To revolutionize paper cup manufacturing by creating durable, eco-friendly solutions that combine innovation and sustainability. Our aim to help businesses reduce their environmental footprint while delivering excellence in every cup.</p>
                                <div className='img-holder'>
                                    <img src={require('../../assets/images/7ec96fe391c141c2ba71d4899edfd13a.png')} alt="" />
                                </div>
                            </div>
                        </Col>
                        <Col
                            className='col-12 col-md-6 d-grid home-hero-ad-content ps-md-5'>
                            <div className='home-hero-head p-3 p-md-4 text-center'>
                                <h4 className='fs-32 fs-md-20 fs-sm-18 m-0'>Our Vision</h4>
                            </div>
                            <div className='home-hero-body d-grid'>
                                <p className='m-0 fs-lg-14 fs-sm-12 text-center'>To be a global leader in sustainable paper cup manufacturing, creating eco-friendly, biodegradable solutions that reduce plastic waste and support a healthier planet. We strive to inspire businesses to embrace environmentally responsible practices for a greener present and future for the world.
                                </p>
                                <div className='img-holder'>
                                    <img src={require('../../assets/images/35f280bbaa9b30363b2b9576c801ff0c.png')} alt="" />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
                {/* <span className='articles-top d-none d-xl-block' />
                <span className='articles-bottom d-none d-xl-block' /> */}
            </div>
        </div>
    )
}

export default HeroAd